export const EXAMPLE_AI_PROMPTS = [
    {
        prompt: 'A modern minimalist house in blue, yellow and red colors',
        style: 'dreamlike',
    },
    { prompt: 'An open seating restaurant terrace', style: 'photo' },
    { prompt: 'A racing car with neon lights', style: 'colorful' },
    {
        prompt: 'Beige colour palette, layered ripped paper background',
        style: 'photo',
    },
    {
        prompt: 'Magical garden with bees and flowers, pastel',
        style: '3d_model',
    },
    { prompt: 'A panda riding a bike through a city', style: 'animated' },
    {
        prompt: 'Moon rising over the mountains, synthwave colours',
        style: 'animated',
    },
    { prompt: 'A variety of desserts on a wooden table', style: 'photo' },
    { prompt: 'A panda eating bamboo in a tropical forest', style: 'colorful' },
    { prompt: 'Vintage poster of a motorcycle', style: '3d_model' },
    { prompt: 'A robot with a glowing visor', style: '3d_model' },
    { prompt: 'A lighthouse on a remote island', style: 'colorful' },
    {
        prompt: 'Tranquil sunset over a serene beach',
        style: 'watercolor',
    },
    {
        prompt: 'Stylish home office setup with a Macbook and coffee',
        style: '3d_model',
    },
    {
        prompt: 'Serene sunrise over a mountain range',
        style: 'photo',
    },
    {
        prompt: 'Quirky kittens playing with a ball of yarn',
        style: 'animated',
    },
    {
        prompt: 'Elegant professional handshake in a corporate setting',
        style: 'photo',
    },
    {
        prompt: 'Delicious, steaming cup of cappuccino with latte art',
        style: 'sketch',
    },
    {
        prompt: 'Vintage travel poster of Paris',
        style: 'poster',
    },
    {
        prompt: 'A peaceful yoga pose by the beach at sunrise',
        style: 'photo',
    },
    {
        prompt: 'A vibrant fruit salad in a glass bowl',
        style: 'pastel_art',
    },
    {
        prompt: 'An astronaut floating in the vastness of space',
        style: '3d_model',
    },
    {
        prompt: 'Surreal landscape with floating islands',
        style: 'dreamlike',
    },
    {
        prompt: 'Plate of delicious sushi',
        style: 'photo',
    },
    {
        prompt: 'Person meditating in a peaceful forest',
        style: 'sketch',
    },
    {
        prompt: 'Vintage car on an open road',
        style: 'dreamlike',
    },
    {
        prompt: 'Cute puppy in a meadow of flowers',
        style: 'colorful',
    },
    {
        prompt: 'Stack of books with a cup of tea',
        style: 'photo',
    },
    {
        prompt: 'Peaceful mountain landscape in autumn',
        style: 'pastel_art',
    },
    {
        prompt: 'Futuristic cityscape',
        style: 'colorful',
    },
    {
        prompt: 'Cup of coffee with latte art',
        style: 'photo',
    },
    {
        prompt: 'Woman reading a book in a cozy room',
        style: 'color_pencil',
    },
    {
        prompt: 'Lively music festival crowd',
        style: 'colorful',
    },
];
